import Link from "next/link";
import { UseCasesNavMenu } from "./use-cases-nav-menu";
import { marketingContainerClassName } from "./marketing-layout";

const navLinkClassName =
  "inline-flex items-center text-[0.9375rem] font-medium leading-none text-zinc-600 outline-brand hover:text-brand-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2";

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-30 shrink-0 border-b border-zinc-200 bg-white/95 backdrop-blur-sm">
      <div
        className={`${marketingContainerClassName} flex items-stretch justify-between gap-4`}
      >
        <Link
          href="/"
          className="flex items-center gap-2.5 py-3 outline-brand focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="/logo.svg"
            alt=""
            width={28}
            height={28}
            className="size-7 shrink-0"
          />
          <span className="text-[1rem] font-bold leading-none text-zinc-950">
            Convert MD to PDF
          </span>
        </Link>
        <nav
          aria-label="Primary"
          className="flex flex-wrap items-stretch gap-x-4 gap-y-2"
        >
          <Link href="/" className={navLinkClassName}>
            Home
          </Link>
          <Link href="/markdown-editor" className={navLinkClassName}>
            Editor
          </Link>
          <Link href="/convert-md-to-pdf" className={navLinkClassName}>
            Upload
          </Link>
          <UseCasesNavMenu />
          <Link href="/#how-it-works" className={navLinkClassName}>
            How it works
          </Link>
          <Link href="/#faq" className={navLinkClassName}>
            FAQ
          </Link>
        </nav>
      </div>
    </header>
  );
}
